import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Authorization header if token stored (fallback to cookie)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("yahweh_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function coverUrl(track) {
  if (!track) return null;
  if (!track.has_cover) return null;
  // Cache-bust on cover_updated_at so admin cover replacements show up
  // immediately. Falls back to created_at for tracks whose cover has never
  // been replaced (still gives the browser cache a stable key).
  const bust = track.cover_updated_at || track.created_at || "";
  const base = `${API}/tracks/${track.id}/cover`;
  return bust ? `${base}?v=${encodeURIComponent(bust)}` : base;
}

export function coverVideoUrl(track) {
  if (!track) return null;
  if (!track.has_cover_video) return null;
  const bust = track.cover_updated_at || track.created_at || "";
  const base = `${API}/tracks/${track.id}/cover-video`;
  return bust ? `${base}?v=${encodeURIComponent(bust)}` : base;
}

export function streamUrl(trackId) {
  return `${API}/tracks/${trackId}/stream`;
}
